/**
 * @author lifei
 * 功能：将枚举类型转换成数组
 * update: 2025-1-6 更新检查是否已经转换了，并使用缓存, enumName 映射的名称，以中心为维度 以 map 为开头的唯一标识。
 */
type TParams = TCommon.Json<TCommon.Json<number | string>>
type TDictItem = TCommon.CustomDictItem

export const enumToList = (): ((params: TParams, regx?: RegExp) => TDictItem[]) => {
  const caches: TCommon.Json<TDictItem[]> = {}
  return (params: TParams, regx: RegExp = /\d+/) => {
    const enumName = Object.keys(params)[0]
    const enumVal = params[enumName]
    if (!caches[enumName]) {
      caches[enumName] = Object.entries(enumVal).reduce((prev, [label, value]) => {
        if (regx.test(value + '')) {
          prev.push({ label, value: String(value), disabled: false })
        }
        return prev
      }, [] as TDictItem[])
    }
    return caches[enumName]
  }
}

export const findByValue = (data: TDictItem[], value?: TDictItem['value']) => {
  return data.find((i) => i.value == value)?.label
}
